import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/add-field")({
    component: RouteComponent,
    beforeLoad: async ({ location }) => {
        throw redirect({
            to: "/ntimev1/$",
            params: {
                _splat: location.pathname,
            },
        });
    },
});

function RouteComponent() {
    return null;
}
